import * as React from 'react'
import { Checkbox as CheckboxPrimitive } from 'radix-ui'
import { CheckIcon, Minus } from 'lucide-react'

import { cn } from '../utils'

function Checkbox({
  className,
  isIndeterminate,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  isIndeterminate?: boolean
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      data-state={props.checked ? (isIndeterminate ? 'indeterminate' : 'checked') : 'unchecked'}
      aria-checked={props.checked ? (isIndeterminate ? 'mixed' : 'true') : 'false'}
      className={cn(
        'peer border-input cursor-pointer dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=indeterminate]:border-primary not-disabled:hover:border-ring not-disabled:hover:ring-ring/50 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-sm border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-default disabled:opacity-50',
        isIndeterminate && 'data-[state=checked]:bg-null data-[state=checked]:text-primary',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        data-state={isIndeterminate ? 'indeterminate' : 'checked'}
        className='flex items-center justify-center text-current transition-none'
      >
        {isIndeterminate ? (
          <Minus className='size-3.5' aria-hidden='true' />
        ) : (
          <CheckIcon className='size-3.5 stroke-3' aria-hidden='true' />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
